export default "__VITE_ASSET__AzbrsnQs__"